import * as React from 'react';
import { ChevronDown, ChevronRight, LucideIcon } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useState } from 'react';
import { useKeycloak } from '@react-keycloak/web';

interface SubMenuItem {
  title: string;
  path: string;
  icon?: LucideIcon;
}

interface MenuItemInterface {
  title: string;
  path?: string;
  icon: LucideIcon;
  children?: SubMenuItem[];
}

interface MenuItemProps {
  item: MenuItemInterface;
}

const MenuItem: React.FC<MenuItemProps> = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { keycloak } = useKeycloak();
  const client =
    process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'api-service-client';
  const isNTSAUser =
    keycloak.tokenParsed?.resource_access?.[client]?.roles?.includes('ntsa');

  if (item.children) {
    return (
      <div className="space-y-1">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`w-full flex items-center space-x-2 p-2 rounded-md hover:bg-gray-100 text-gray-700 hover:text-gray-900`}
        >
          <span>{item.title}</span>
          {isOpen ? (
            <ChevronDown size={16} className="ml-auto" />
          ) : (
            <ChevronRight size={16} className="ml-auto" />
          )}
        </button>
        {isOpen && (
          <ul className="pl-6 space-y-1">
            {item.children.map((child, index) => {
              const getClassName = ({ isActive }: { isActive: boolean }) => {
                if (isNTSAUser) {
                  return `w-full flex items-center space-x-2 p-2 rounded-md ${
                    isActive
                      ? 'bg-green-500 text-white'
                      : 'bg-green-500 text-white hover:bg-grey-600'
                  }`;
                }
                return `w-full flex items-center space-x-2 p-2 rounded-md ${
                  isActive
                    ? 'bg-gray-200 text-gray-900'
                    : 'hover:bg-gray-100 text-gray-700 hover:text-gray-900'
                }`;
              };

              return (
                <li key={index}>
                  <NavLink to={child.path} className={getClassName}>
                    <span>{child.title}</span>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    );
  }

  return (
    <NavLink
      to={item.path!}
      className={({ isActive }) => {
        if (isNTSAUser) {
          return `w-full flex items-center space-x-2 p-2 rounded-md ${
            isActive
              ? 'bg-green-600 text-white courier'
              : 'bg-green-500 text-white hover:bg-green-600'
          }`;
        }
        return `w-full flex items-center space-x-2 p-2 rounded-md ${
          isActive
            ? 'bg-gray-200 text-gray-900'
            : 'hover:bg-gray-100 text-gray-700 hover:text-gray-900'
        }`;
      }}
    >
      <span>{item.title}</span>
      <ChevronRight size={16} className="ml-auto" />
    </NavLink>
  );
};

export default MenuItem;
